<template>
    <div class="footer">
        <div class="footer-top">
            <div class="footer-top-left">
                <div class="helper">
                    <div class="helper-title">
                        球场
                    </div>
                    <router-link to="/courts" class="helper-item">球场大全</router-link>
                    <router-link to="/preferentials" class="helper-item">特惠球场</router-link>
                    <router-link to="/travels" class="helper-item">旅游+打球</router-link>
                    <router-link to="/search-map" class="helper-item">地图搜索</router-link>
                    <router-link to="/frontTicket" class="helper-item">套票会籍</router-link>
                </div>
                <div class="helper">
                    <div class="helper-title">
                        文章资讯
                    </div>
                    <router-link to="/articles" class="helper-item">高尔夫快讯</router-link>
                    <router-link to="/recruit" class="helper-item">招聘信息</router-link>
                </div>
                <div class="helper">
                    <div class="helper-title">
                        订单
                    </div>
                    <router-link to="/my-orders" class="helper-item">我的订单</router-link>
                    <router-link to="/secondhands" class="helper-item">二手物品</router-link>
                </div>
            </div>
            <div class="footer-top-right">
                <div class="qr">
                    <img src="https://apitest.golfreservations.club/uploadpictures/other/minicode.jpg" class="qr-img">
                    <div class="qr-title">
                        微信小程序
                    </div>
                </div>
                  <div class="qr" style="margin-right:50px;">
                    <img src="../assets/gongzhonghaoqrcode.jpg" class="qr-img">
                    <div class="qr-title">
                        微信公众号
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-mid">
            <router-link to="/" class="footer-mid-item">服务协议</router-link>
            <div class="border"> </div>
            <router-link to="/" class="footer-mid-item">免责条款</router-link>
            <div class="border"> </div>
            <router-link to="/" class="footer-mid-item">隐私协议</router-link>
        </div>
          <div class="footer-bottom">
            <a href="https://beian.miit.gov.cn/" class="footer-bottom-item">京ICP备18030041号-2</a>
        </div>
        <!-- <div class="footer-bottom">
            <span class="footer-bottom-item">{{ new Date().getFullYear() }} &copy; 高尔夫预订网</span>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'SunFooter',
    data () {
        return {
        }
    },
    created () {
    },
    methods: {

    }
}
</script>

<style lang="less">
.footer {
    background: #535457;
    color: #ffffff;
    padding: 0 100px;
    .footer-top {
        display: flex;
        justify-content: space-between;

        .footer-top-left {
            padding-top: 20px;
            display: flex;
            // flex: 1;
            justify-content: space-between;
            align-items: flex-start;

            .helper {
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
                width: 80px;
                margin-left: 30px;

                .helper-title {
                    font-size: 16px;
                    line-height: 30px;
                    color: #ffffff;
                }

                .helper-item {
                    color: #ffffff;
                    display: block;
                    line-height: 26px;
                }
            }

            .friend {
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
                margin-left: 30px;

                .friend-title {
                    font-size: 16px;
                    line-height: 30px;
                    color: #ffffff;
                }

                .friend-header {
                    .friend-item:nth-child(1) {
                        padding-left: 0;
                    }
                    .friend-item {
                        text-align: center;
                        color: #ffffff;
                        line-height: 26px;
                        padding: 0px 10px;
                    }
                }
            }
        }

        .footer-top-right {
            display: flex;
            width: 380px;
            justify-content: space-between;
            // justify-content: flex-start;

            align-self: center;

            .qr {
                .qr-img {
                    display: block;
                    width: 110px;
                    height: 110px;
                }

                .qr-title {
                    text-align: center;
                    line-height: 30px;
                    color: #ffffff;
                }
               
            }
        }
    }

    .footer-mid {
        display: flex;
        justify-content: center;
        align-items: center;

        .footer-mid-item {
            color: #ffffff;
            padding: 0 20px;
            height: 22px;
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
        }

        .border {
            display: block;
            width: 1px;
            height: 16px;
            background: #ffffff;
        }
    }

    .footer-bottom {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
        padding-bottom: 30px;

        .footer-bottom-item {
            color: #ffffff;
            padding: 0 20px;
            height: 22px;
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
            line-height: 22px;
            display: flex;
            align-items: center;

            img {
                width: 21px;
                height: 22px;
                margin-right: 10px;
            }
        }

        span {
            color: #ffffff;
        }
    }
}
</style>
